import posthog from 'posthog-js';

/**
 * PostHog: product analytics focused on catching bad user experiences —
 * autocapture, session recordings, and JS/network error tracking.
 * Distinct id is the user's email (set via identifyPosthogUser), not an internal user id.
 */
export function initPosthog() {
  if (typeof window === 'undefined') return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;

  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    ui_host: 'https://us.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      recordCrossOriginIframes: false,
    },
  });
}

/** Identify the PostHog user with email as the distinct id. Call after successful auth. */
export function identifyPosthogUser(user, team) {
  if (typeof window === 'undefined') return;
  const email = user?.email;
  if (!email || typeof email !== 'string') return;
  try {
    posthog.identify(email, { email });
    const teamId = team?.id ?? team?._id;
    if (teamId != null && String(teamId).trim() !== '') {
      posthog.group('team', String(teamId), { name: team?.name });
    }
  } catch (e) {
    console.warn('PostHog identify failed', e);
  }
}

/** Reset PostHog identity. Call on logout BEFORE clearing localStorage. */
export function resetPosthogIdentity() {
  if (typeof window === 'undefined') return;
  try {
    posthog.reset();
  } catch {
    /* swallow */
  }
}

export default posthog;
